import React, { Component } from "react";
import injectSheet from "react-jss";
import Color from "color";
import { withRouter, Link, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { palette } from "../../Theme/Theme";
import * as Actions from "../../Actions/Actions";
import logo from "../../../assets/spectiv_color.png";
// import ReactGA from 'react-ga'
import Responsive from "react-responsive";

// const Desktop = props => <Responsive {...props} minWidth={1021} />
// const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={1299} />
// const Mobile = props => <Responsive {...props} maxWidth={1020} />

const mapStateToProps = state => {
  return {
    sideNavVisible: state.mainState.sideNavVisible,
    library: state.mainState.library,
    libraryState: state.mainState.libraryState
  };
};

class SideNav extends Component {
  render() {
    const { classes } = this.props;
    let width = "0vw";
    let maxWidth = "0vw";
    let display = "none";
    let marginLeft = "-20vw";
    let opacity = "0";
    let categories = classes.categoriesLeave;
    if (this.props.sideNavVisible) {
      width = "20vw";
      maxWidth = "100vw";
      display = "inline";
      marginLeft = "0vw";
      opacity = "1";
      categories = classes.categoriesEnter;
    }
    return (
      <React.Fragment>
        <div
          onClick={() => {
            this.props.dispatch({ type: "TOGGLE_SIDE_NAV" });
          }}
          style={{ minWidth: width, maxWidth: maxWidth }}
          className={classes.container}
        >
          <div
            style={{ opacity: opacity, marginLeft: marginLeft }}
            className={classes.title}
          >
            Categories
          </div>
          {this.props.libraryState.loaded
            ? this.props.library.view.map((content, index) => {
                return (
                  <a
                    href={`#ThumbNail_${index}`}
                    key={index}
                    style={{
                      opacity: opacity,
                      marginLeft: marginLeft,
                      textDecoration: "none"
                    }}
                    className={categories}
                  >
                    {content.title}
                  </a>
                );
              })
            : null}
        </div>
        <div
          onClick={() => {
            this.props.dispatch({ type: "TOGGLE_SIDE_NAV" });
          }}
          style={{ display: display }}
          className={classes.sideNavContainer}
        />
      </React.Fragment>
    );
  }
}

const styles = {
  categoriesLeave: {
    transition: "all .2s ease-out .2s",
    color: palette.white,
    padding: ".8rem",
    paddingLeft: "1rem",
    fontSize: "1.5rem"
  },
  categoriesEnter: {
    transition: "all .2s ease-out .3s",
    color: palette.white,
    fontSize: "1.5rem",
    textAlign: "left",
    padding: ".8rem",
    paddingLeft: "1rem",
    "&:hover": {
      color: palette.blue,
      transition: "all .4s",
      cursor: "pointer"
    }
  },
  sideNavContainer: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    backgroundColor: "transparent",
    zIndex: "4"
  },
  container: {
    overflowY: "scroll",
    transition: "all .2s ease-out .2s",
    height: "100vh",
    background: `linear-gradient(90deg, ${Color("black").alpha(1)}, ${Color(
      "black"
    ).alpha(0.8)})`,
    position: "fixed",
    zIndex: "5",
    top: "0",
    left: "0",
    bottom: "0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "left",
    flexDirection: "column"
  },
  title: {
    transition: "all .2s ease-out .3s",
    color: palette.white,
    fontSize: "1.8rem",
    fontWeight: "600",
    textAlign: "center",
    margin: ".5rem",
    borderBottom: "1px solid",
    padding: ".5rem"
  }
};

export default withRouter(
  connect(mapStateToProps)(injectSheet(styles)(SideNav))
);



// WEBPACK FOOTER //
// ./src/js/Components/Home/SideNavigation.jsx